import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { colors, radius, spacing, typography, transitions } from "../utils/designTokens";

const ScreenHeader = ({ icon: Icon, title, subtitle, onBack, size = "default" }) => {
  const isCompact = size === "compact";
  const titleStyle = isCompact ? styles.titleCompact : styles.title;
  const subtitleStyle = isCompact ? styles.subtitleCompact : styles.subtitle;
  return (
    <div style={isCompact ? styles.headerCompact : styles.header}>
      {onBack && (
        <button style={styles.backBtn} onClick={onBack} title="Volver">
          <FaArrowLeft size={14} />
        </button>
      )}
      <div>
        <h2 style={titleStyle}>
          {Icon && <Icon size={isCompact ? 14 : 16} style={{ marginRight: 8 }} />}
          {title}
        </h2>
        {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
      </div>
    </div>
  );
};

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    gap: spacing[3],
    marginBottom: spacing[5],
  },
  headerCompact: {
    display: "flex",
    alignItems: "center",
    gap: spacing[3],
    marginBottom: spacing[3],
  },
  backBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 36,
    height: 36,
    borderRadius: radius.sm,
    border: `1px solid ${colors.gray200}`,
    backgroundColor: colors.white,
    cursor: "pointer",
    color: colors.gray900,
    transition: `all ${transitions.fast}`,
    flexShrink: 0,
  },
  title: {
    fontSize: typography.sizes.xl,
    fontWeight: 400,
    color: colors.primary,
    margin: 0,
    letterSpacing: "-0.01em",
    display: "flex",
    alignItems: "center",
    fontFamily: typography.fontFamily,
  },
  titleCompact: {
    fontSize: typography.sizes.lg,
    fontWeight: 400,
    color: colors.primary,
    margin: 0,
    letterSpacing: "-0.01em",
    display: "flex",
    alignItems: "center",
    fontFamily: typography.fontFamily,
  },
  subtitle: {
    fontSize: typography.sizes.md,
    color: colors.gray600,
    margin: "2px 0 0",
    fontFamily: typography.fontFamily,
  },
  subtitleCompact: {
    fontSize: typography.sizes.sm,
    color: colors.gray600,
    margin: "2px 0 0",
    fontFamily: typography.fontFamily,
  },
};

export default ScreenHeader;
